import { docFromPlainText, type TiptapDoc } from '@odo/shared-ui';
import {
    createEmptyDraft,
    isDescriptionOverCap,
    type VirtualAppointmentDraft
} from '../../../virtual-appointments/virtualAppointmentDraft';

// One paragraph per line, blank lines kept (the patient-note SQL backfill rule). A note with more
// lines than the node cap becomes a single hard-broken paragraph so a draft save never drops it.
export function legacyNoteToDoc(note: string): TiptapDoc {
    const text = note.replace(/\r\n?/g, '\n');
    const doc = docFromPlainText(text);
    if (!isDescriptionOverCap(doc)) return doc;
    const inline = text
        .split('\n')
        .flatMap((line, i) => [
            ...(i > 0 ? [{ type: 'hardBreak' }] : []),
            ...(line.length > 0 ? [{ type: 'text', text: line }] : [])
        ]);
    return { type: 'doc', content: [{ type: 'paragraph', content: inline }] };
}

// The pre-VA free-text note becomes one new planned VA; type and trigger are left for the user.
export function legacyNoteToDraft(note: string): VirtualAppointmentDraft | null {
    if (note.trim() === '') return null;
    return { ...createEmptyDraft(), descriptionDoc: legacyNoteToDoc(note) };
}
